import { render, staticRenderFns } from "./GanttBar.vue?vue&type=template&id=3230ed52&scoped=true&lang=pug&"
import script from "./GanttBar.vue?vue&type=script&lang=js&"
export * from "./GanttBar.vue?vue&type=script&lang=js&"
import style0 from "./GanttBar.vue?vue&type=style&index=0&id=3230ed52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230ed52",
  null
  
)

export default component.exports